import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { uiChangeSkladName } from '../../../actions/ui';
import EntriesApi from '../../../API/warehouse/entries-api';
import delete_img from '../../../assets/media/bucket.svg';
import { Row } from '../../../components/Basic/Blocks';
import { Button, ButtonWithTooltip } from '../../../components/Basic/Buttons';
import { Icon } from '../../../components/Basic/Elements';
import { Content } from '../../../components/Basic/Global';
import { Select } from '../../../components/Basic/Inputs';
import { HeaderTitle, Table, TableCell, TableHeader, TableLine } from '../../../components/Basic/Table';
import {
  ENTRIES_STATUS,
  ENTRIES_STATUS_COLORS,
  MAP_RETURNS,
  MAP_SKLAD,
  RESERVES_STATUS_COLORS,
  SKLADS_WAREHOUSE,
  TO_ENTRY
} from '../../../constans';
import { formFullDate, getDate } from '../../../utils';
import styles from './styles.module.scss';
const width = ['50px', '120px', '120px', '200px', '250'];

function EntriesPage() {
  const [entries, setEntries] = useState([]);
  const [limit, changeLimit] = useState(20);
  // const { role } = useSelector((store) => ({
  //   role: store.user.role,
  //   login: store.user.login,
  // }));
  const skladName = useSelector((store) => store.ui.skladName);
  const dispatch = useDispatch();
  const user = useSelector((store) => store.user);

  const getEntries = () => {
    EntriesApi.getAllEntries({ data: { skladName: skladName.short_name } }).then((r) => setEntries(r.entries));
  };
  const onDelete = (id) => {
    EntriesApi.deleteEntry({ data: { entryId: id } }).then(() => getEntries());
  };
  useEffect(() => {
    getEntries();
  }, [skladName.short_name]);

  return (
    <>
      <Content>
        <Row style={{ width: '100%', marginBottom: '20px' }}>
          <>
            <Select
              label="Город"
              select={skladName}
              list={SKLADS_WAREHOUSE.filter((item) => user.sklads[item.short_name])}
              valueFn={(p) => p.name}
              onSelect={(v) => dispatch(uiChangeSkladName(v))}
              width="200px"
              style={{ marginRight: '15px' }}
            />
          </>
          
        </Row>

        <Table>
          <TableHeader whiteHeader={true}>
            <HeaderTitle width={width[0]}>ID</HeaderTitle>
            <HeaderTitle width={width[2]}>Дата создания</HeaderTitle>
            <HeaderTitle width={width[1]}>Статус</HeaderTitle>
            <HeaderTitle width={width[1]}>Статистика</HeaderTitle>
            <HeaderTitle width={width[1]}>Город</HeaderTitle>
            <HeaderTitle width={width[1]}>Тип внесения</HeaderTitle>
            <HeaderTitle width={width[1]}>Создатель</HeaderTitle>
            <HeaderTitle width={width[3]}>Дата создания</HeaderTitle>
          </TableHeader>
          {entries.slice(0, limit).map((item) => (
            <TableLine key={item.id}>
              <NavLink to={TO_ENTRY(item.id)} className={styles.line_table_link}>
                <TableCell width={width[0]}>{item.id}</TableCell>
                <TableCell width={width[2]}>{getDate(item.created_at)}</TableCell>
                <TableCell width={width[1]} style={{ color: `${ENTRIES_STATUS_COLORS[item.status]}` }}>
                  {ENTRIES_STATUS[item.status]}
                </TableCell>
                <TableCell width={width[1]}>{`${item.count}/${item.statistic.true || 0}/${item.statistic.false || 0}`}</TableCell>
                <TableCell width={width[1]}>{MAP_SKLAD[item.skladName]}</TableCell>
                <TableCell width={width[1]}>{MAP_RETURNS[item.reason]}</TableCell>

                <TableCell width={width[1]}>{item.creator}</TableCell>
                <TableCell width={width[3]}>{formFullDate(item.created_at)}</TableCell>
              </NavLink>
              {(user.role === 'admin' || user.role === 'owner') && (
                <TableCell>
                  <ButtonWithTooltip tooltip={'Удалить'} onClick={() => onDelete(item.id)}>
                    <Icon src={delete_img} width={'20px'} />
                  </ButtonWithTooltip>
                </TableCell>
              )}
            </TableLine>
          ))}
        </Table>

        {entries.length >= 0 && entries.length > limit && (
          <Button className={styles.show_more} onClick={() => changeLimit(limit + 10)}>
            Посмотреть ещё <span className={styles.arrow_blue} />
          </Button>
        )}
      </Content>
    </>
  );
}

export default EntriesPage;
